// [uTheory](http://utheory.com) - Copyright (c) Gregory Ristow 2014
//
// ## Staff
//
// A staff object holds a clef, which can be named.
import type { ClefName } from 'shared/definitions/musicTheory/clefs';
import Clef from './clef';
import utils from '../utils';
import type { AriaStringOptions } from './note';
import type CustomKeySignature from './customKeySignature';

export default class Staff {
  clef!: Clef;

  customKeySignature?: CustomKeySignature;

  // Public constructor
  constructor(clef: Clef | ClefName) {
    this.setClef(clef);
  }

  setClef(clef: Clef | ClefName = 'treble') {
    if (clef instanceof Clef) this.clef = clef;
    else this.clef = new Clef(clef);
  }

  getClef() {
    return this.clef;
  }

  setCustomKeySignature(customKeySig: CustomKeySignature) {
    this.customKeySignature = customKeySig;
  }

  getCustomKeySignature(): CustomKeySignature | undefined {
    return this.customKeySignature;
  }

  deleteCustomKeySignature() {
    delete this.customKeySignature;
  }

  toAriaString({ clef = true }: AriaStringOptions = {}) {
    if (!clef) return '';
    return `${utils.titleCase(this.clef.toString())} clef`;
  }

  toString() {
    const str = `Staff: ${this.clef} clef`;
    return str;
  }
}
